<template>
 <v-tooltip bottom>
  <template v-slot:activator="{ on }">
    <v-btn icon ripple v-on="on" @click.prevent="versteckeAnfrage(anfrage.hashid)">
      <v-icon color="grey lighten-1">{{ icon }}</v-icon>
    </v-btn>     
   </template>
  <span>Anfrage ausblenden</span>
</v-tooltip> 
</template>

<script>
import axios from 'axios'
export default {
  components: {},
  data () {
    return {
      icon: 'visibility_off'
    }
  },
  props: ['anfrage'],
  methods: {
    versteckeAnfrage: function (hashid) {
      const app = this
      axios
      .post('/api/v1/anfrageverstecken/' + hashid)
      .then(function (resp) {
       // console.log(hashid)
        app.$emit('anfragerefresh', app.anfrage)
      })
      .catch(function (error) {
        console.log(error)
      })
    }
  },
  computed: {}
}
</script>